
<h3 class="title-form">Debito por operaciones locales</h3>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Ventas gravadas:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.goodsSales)" style="text-align:right;">
			{{form.goodsSales | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Servicios gravados:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.servicesSales)" style="text-align:right;">
			{{form.servicesSales | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<h3 class="title-form">Crédito por operaciones locales</h3>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Otras compras:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.goodsPurchases)" style="text-align:right;">
			{{form.goodsPurchases | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Servicios adquiridos:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.servicesPurchases)" style="text-align:right;">
			{{form.servicesPurchases | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Compras y servicios adquiridos de pequeños contribuyentes:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.smallPurchases)" style="text-align:right;">
			{{form.smallPurchases | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		IVA conforme constancias de exención recibidas:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.exemptions)" style="text-align:right;">
			{{form.exemptions | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Remanente de crédito fiscal del período anterior:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.fiscalCreditLastMonth)" style="text-align:right;">
			{{form.fiscalCreditLastMonth | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<h3 class="title-form">
	Determinación del crédito fiscal o impuesto a pagar
</h3>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Crédito fiscal para el período siguiente por operaciones locales (Créditos mayor que Débitos):
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.fiscalCreditNextMonth)" style="text-align:right;">
			{{form.fiscalCreditNextMonth | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Remanente de retenciones del IVA del período anterior:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.withholdingsLastMonth)" style="text-align:right;">
			{{form.withholdingsLastMonth | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		(-) Constancias de retenciones del IVA recibidas en el período a declarar:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.withholdings)" style="text-align:right;">
			{{form.withholdings | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Saldo de retenciones para el período siguiente:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.withholdingsNextMonth)" style="text-align:right;">
			{{form.withholdingsNextMonth | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>